(function () {
  var container = document.querySelector('[data-snippet="kos-uebersicht"]');
  if (!container) return;

  var elements = container.querySelectorAll('.kos__oD__Element');
  var filterWrapper = container.querySelector('.kos__oD__Filter__Wrapper');
  var dropdown = container.querySelector('#kos__oD__Select');
  var resetButton = container.querySelector('#kos__oD__Reset');

  document.addEventListener('DOMContentLoaded', function () {
    applyWildcard();
    sortGridNewestFirst();
    buildFilters('category');

    if (resetButton) resetButton.onclick = resetFilters;

    dropdown.onchange = function () {
      var val = this.value;
      var selection = 'category';
      if (val === 'Speaker') selection = 'speakers';
      if (val === 'Zeit') selection = 'time';
      buildFilters(selection);
    };
  });

  function applyWildcard() {
    var url = window.location.href;
    var wildcard = '';
    if (url.includes('bauer')) wildcard = 'wrd=bauer';
    if (url.includes('meta')) wildcard = 'wrd=meta';
    if (url.includes('direct')) wildcard = 'wrd=direct';
    if (!wildcard) return;

    elements.forEach(function (el) {
      var link = el.querySelector('a');
      if (!link) return;
      var videoId = el.getAttribute('data-videoid');
      link.href = '/pages/kos-detail?videoid=' + videoId + '&' + wildcard;
    });
  }

  function getUniqueValues(attr) {
    var map = {};
    elements.forEach(function (el) {
      var raw = el.getAttribute(attr) || '';
      raw.split(',').forEach(function (v) {
        var trimmed = v.trim();
        if (trimmed) map[trimmed] = true;
      });
    });
    return Object.keys(map).sort(function (a, b) {
      return a.localeCompare(b, 'de');
    });
  }

  // Single source of truth for parsing "DD.MM.YYYY" (or "DD.MM.YY") date strings.
  // Normalizes 2-digit years, guards against empty/broken values, and returns a
  // sortable object. sortKey has day-level precision (y*10000 + m*100 + d) so the
  // grid can order within a month; callers needing month granularity use y*100 + m.
  function parseKosDate(dateString) {
    if (!dateString) return null;
    var parts = dateString.split('.');
    if (parts.length < 3) return null;
    var d = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var y = parseInt(parts[2], 10);
    if (isNaN(d) || isNaN(m) || isNaN(y)) return null;
    if (y < 100) y += 2000;
    return { d: d, m: m, y: y, sortKey: y * 10000 + m * 100 + d };
  }

  function getMonthYear(dateString) {
    var parsed = parseKosDate(dateString);
    if (!parsed) return '';
    var germanMonths = [
      'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];
    return germanMonths[parsed.m - 1] + ' ' + parsed.y;
  }

  function sortGridNewestFirst() {
    var wrapper = container.querySelector('.kos__oD__Element__Wrapper');
    if (!wrapper) return;
    var items = Array.prototype.slice.call(
      wrapper.querySelectorAll('.kos__oD__Element')
    );
    items.sort(function (a, b) {
      var da = parseKosDate(a.getAttribute('data-date'));
      var db = parseKosDate(b.getAttribute('data-date'));
      var ka = da ? da.sortKey : -Infinity; // undated tiles sink to the end
      var kb = db ? db.sortKey : -Infinity;
      return kb - ka; // descending: newest first
    });
    items.forEach(function (item) { wrapper.appendChild(item); });
  }

  function getUniqueTimeValues() {
    var map = {};
    elements.forEach(function (el) {
      var raw = el.getAttribute('data-date') || '';
      var parsed = parseKosDate(raw);
      if (!parsed) return;
      var label = getMonthYear(raw);
      // Dedup by label ("Juni 2026"); keep a month-level key for ordering.
      if (!(label in map)) {
        map[label] = parsed.y * 100 + parsed.m;
      }
    });
    return Object.keys(map).sort(function (a, b) {
      return map[b] - map[a]; // descending: newest month first
    });
  }

  function buildFilters(selection) {
    filterWrapper.innerHTML = '';

    var values;
    if (selection === 'category') {
      values = getUniqueValues('data-category');
    } else if (selection === 'speakers') {
      values = getUniqueValues('data-speakers');
    } else if (selection === 'time') {
      values = getUniqueTimeValues();
    }

    values.forEach(function (val) {
      var btn = document.createElement('button');
      btn.textContent = val;
      btn.classList.add('kos__oD__Filter');
      btn.classList.add('responsive-text2--bold');
      btn.setAttribute('data-topic', val);
      btn.setAttribute('data-filter-type', selection);
      btn.setAttribute('data-state', 'not selected');
      btn.onclick = function () { handleClick(val, selection, this); };
      filterWrapper.appendChild(btn);
    });

    showHideElements(elements, 'show');
  }

  function handleClick(key, selection, element) {
    var state = element.getAttribute('data-state');

    if (state === 'not selected') {
      element.setAttribute('data-state', 'selected');
    } else {
      element.setAttribute('data-state', 'not selected');
    }
    element.classList.toggle('kos__oD__Filter__selected');

    applyFilters(selection);
  }

  function applyFilters(selection) {
    var filterBtns = filterWrapper.querySelectorAll('.kos__oD__Filter');
    var selectedValues = [];

    filterBtns.forEach(function (btn) {
      if (btn.getAttribute('data-state') === 'selected') {
        selectedValues.push(btn.getAttribute('data-topic'));
      }
    });

    if (selectedValues.length === 0) {
      showHideElements(elements, 'show');
      return;
    }

    elements.forEach(function (el) {
      var match = false;
      var attrValue = '';

      if (selection === 'time') {
        var dateRaw = el.getAttribute('data-date') || '';
        attrValue = dateRaw ? getMonthYear(dateRaw) : '';
      } else if (selection === 'category') {
        attrValue = el.getAttribute('data-category') || '';
      } else if (selection === 'speakers') {
        attrValue = el.getAttribute('data-speakers') || '';
      }

      var elValues = attrValue.split(',').map(function (v) { return v.trim(); });

      for (var i = 0; i < selectedValues.length; i++) {
        if (elValues.indexOf(selectedValues[i]) !== -1) {
          match = true;
          break;
        }
      }

      el.style.display = match ? '' : 'none';
    });
  }

  function resetFilters() {
    var filterBtns = filterWrapper.querySelectorAll('.kos__oD__Filter');
    filterBtns.forEach(function (btn) {
      btn.setAttribute('data-state', 'not selected');
      btn.classList.remove('kos__oD__Filter__selected');
    });
    showHideElements(elements, 'show');
  }

  function showHideElements(els, state) {
    els.forEach(function (el) {
      el.style.display = state === 'hide' ? 'none' : '';
    });
  }
})();
